import { render, staticRenderFns } from "./RegistraPeso.vue?vue&type=template&id=19e0e95a&"
import script from "./RegistraPeso.vue?vue&type=script&lang=js&"
export * from "./RegistraPeso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports